/* global L, Window */

/**
 * Map marker options for Sell Timber: keys match persisted `properties.icon` on placed Point features.
 * `path` is concatenated with `Window.static_path` where the asset URL is needed.
 */
export const DEFAULT_SELL_TIMBER_MARKER_ICON = 'bestand';

/** Keys = persisted `properties.icon` on placed Point features. `path` is under `Window.static_path`. */
export const SELL_TIMBER_MARKER_ICON_OPTIONS = {
  bestand: {
    path: 'img/map-markers/marker-tree.svg',
    label: 'Bestånd',
    defaultName: 'Bestånd'
  },
  vagbom_med_kod: {
    path: 'img/map-markers/marker-stop.svg',
    label: 'Vägbom med kod',
    defaultName: 'Vägbom med kod'
  },
  vagbom: {
    path: 'img/map-markers/marker-info.svg',
    label: 'Vägbom',
    defaultName: 'Vägbom'
  },
  avlag: {
    path: 'img/map-markers/marker-location.svg',
    label: 'Avlägg',
    defaultName: 'Avlägg'
  },
  biobransle: {
    path: 'img/map-markers/marker-biobransle.svg',
    label: 'Biobränsle',
    defaultName: 'Biobränsle'
  }
};

/** Icon key for grot-only flow; excluded from {@link sellTimberTimberMarkerIconEntries}. */
export const SELL_TIMBER_GROT_MARKER_ICON_KEY = 'biobransle';

/** Marker types offered in standard (non-grot) Sell Timber step 2 picker. */
export function sellTimberTimberMarkerIconEntries() {
  return Object.entries(SELL_TIMBER_MARKER_ICON_OPTIONS).filter(
    ([key]) => key !== SELL_TIMBER_GROT_MARKER_ICON_KEY
  );
}

/** Leaflet pin height — keep in sync with {@link createSellTimberPlacedMarkerLeafletIcon} `iconSize`. */
export const SELL_TIMBER_MARKER_PIN_HEIGHT_PX = 43;

/**
 * @param {string} [iconKey]
 * @returns {L.Icon | null}
 */
export function createSellTimberPlacedMarkerLeafletIcon(iconKey) {
  if (typeof L === 'undefined' || !L?.icon) return null;
  const opt =
    SELL_TIMBER_MARKER_ICON_OPTIONS[iconKey] ??
    SELL_TIMBER_MARKER_ICON_OPTIONS[DEFAULT_SELL_TIMBER_MARKER_ICON];
  if (!opt?.path) return null;
  return L.icon({
    iconUrl: `${Window.static_path}${opt.path}`,
    iconSize: [30, SELL_TIMBER_MARKER_PIN_HEIGHT_PX],
    shadowSize: [30, SELL_TIMBER_MARKER_PIN_HEIGHT_PX],
    iconAnchor: [15, SELL_TIMBER_MARKER_PIN_HEIGHT_PX],
    shadowAnchor: [30, 43],
    popupAnchor: [0, -24]
  });
}

export const SELL_TIMBER_MARKER_NAME_LABEL_MIN_ZOOM = 10;
